<template>
    <div>
        <div class="automation" v-bind:class="{ 'automation--show-tour' : showEditDialog, 'automation--finished-editing' : finishedEditing}">

            <div class="card">

                <div class="automation__actions">
                    <ul>
                        <li v-on:click.stop="editAutomation"><i class="fas fa-edit"></i></li>
                        <li v-on:click.stop="confirmDuplicateAutomation"><i class="fas fa-copy"></i></li>
                        <li v-on:click="confirmDeleteAction"><i class="fas fa-trash-alt"></i></li>
                    </ul>
                </div>

                <div class="card-header automation__header" v-bind:class="{'automation__header--off': !automation.active}">
                    <template v-if="isForm">
                        <button class="btn btn-primary" v-on:click="openFormTemplate">
<!--                            <i class="fab fa-wpforms" v-bind:class="{'automation__template&#45;&#45;not-set': typeof automation.formTemplateReference === 'undefined'}"></i>-->
                            <i class="fab fa-wpforms"></i>
                        </button>
                    </template>
                    <template v-if="isSendForm">
                        <i class="fas fa-plus automation-combine-icon"></i>
                    </template>

                    <template v-if="isUpsell">
                      <i class="fas fa-cart-plus automation-type-icon"></i>
                      <i class="fas fa-plus automation-combine-icon"></i>
                    </template>

                    <button v-if="isSendEmail" class="btn btn-primary" v-on:click="openEmailTemplate"><i class="far fa-envelope"></i></button>

                    <i v-if="isSendOmniChannel && isSendSMSOrOmniChannelWithSMS" class="fas fa-plus automation-combine-icon"></i>

                    <button v-if="isSendSMSOrOmniChannelWithSMS" class="btn btn-primary automation-coming-soon" disabled><i class="fas fa-sms"></i></button>

                    <i v-if="isToDo" class="fas fa-list"></i>

                    <button v-if="isSendWhatsApp" class="btn btn-primary" v-on:click="openWhatsAppTemplate"><i class="fas fa-comments"></i></button>

                    <button v-if="isWebhook" class="btn btn-primary" v-on:click="openWebhook">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 92 81"
                           fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" class="automation__header--webhook">
                        <path d="M59.165 62.735l1.967 2.483c3.4 3.469 9.202 3.66 12.836.414 3.801-3.374 3.967-9.008.4-12.509-3.5-3.438-9.501-3.756-12.769-.128-1.967 2.197-4 2.483-6.601 2.419l-20.17-.032c.433 9.04-3.134 14.642-10.235 15.979-6.935 1.305-13.303-2.069-15.57-8.244-2.567-7.003.6-12.605 9.735-17.06l-2.067-7.162C6.722 40.963-.712 50.193.054 60.57c.667 9.167 8.402 17.284 17.87 18.748 5.134.796 9.968-.032 14.436-2.451 5.768-3.119 9.101-8.053 10.668-14.132h16.136zm-6.301-36.318c.4-.987.8-1.782 1.1-2.61 1.034-2.992.4-5.698-1.6-8.117-2.434-2.96-6.735-4.043-10.369-2.706-3.668 1.337-6.034 4.807-5.868 8.594.167 3.883 2.867 7.321 7.068 8.021 2.5.414 3.734 1.528 4.867 3.502 3.301 5.825 6.768 11.554 10.202 17.347 8.235-5.22 15.036-5.061 20.104.382a12.41 12.41 0 0 1 .233 16.774c-5.034 5.666-11.802 5.888-19.537 1.114l-6.134 4.902c7.835 7.448 19.003 8.435 27.838 2.642 8.635-5.666 11.602-16.52 7.235-25.687-3.634-7.608-13.736-14.706-27.172-10.727l-7.968-13.432zm-10.702 7.13c-8.701-4.201-11.902-9.74-9.802-16.52 1.867-5.984 8.134-9.867 14.502-8.976 3.2.477 5.968 1.719 8.168 4.075 3.301 3.597 4.034 7.798 3.034 12.477l7.535 1.942c3.201-8.403-.567-18.207-8.768-23.236-8.568-5.252-19.637-4.169-26.905 2.673-3.801 3.565-5.868 7.926-6.368 12.987-.667 7.098 2.4 12.859 7.601 17.793l-8.268 13.178c-.733.064-1.2.064-1.666.128-5.401.732-9.235 5.347-8.335 10.026 1.033 5.315 6.101 8.562 11.269 7.257 5.501-1.369 8.435-6.43 6.368-11.65-.767-1.878-.3-3.087.667-4.551l10.969-17.602z"
                              stroke="none"/>
                      </svg>
                    </button>
                </div>

                <div class="card-body">
                    <div ref="automationTypeAndName">
                      <span class="automation-title__action">{{automationTypeAsString}}</span>
                      <span class="automation-title__name">{{automation.name}}</span>
                    </div>
                    <span v-if="isCommunicationSent" class="automation-state__notification-mode tooltip-container">
                        <div class="task-icon">
                          <i class="far fa-envelope"></i>
                          <i v-if="isPauseNewTasks" class="fas fa-pause task-state task-state--paused"></i>
                        </div>
                        <template v-if="isCommunicationHostOnly">Send to You</template>
<!--                        <template v-if="isCommunicationBCCHost">Send to {{sendingToGuestOrAgent}}, BCC you</template>-->
                        <template v-if="isCommunicationGuestOnly">Send to {{sendingToGuestOrAgent}}</template>
                        <template v-if="isCommunicationThirdParty">Send to Third Party</template>
                        <i v-if="hasAgentTrueCondition && (isCommunicationBCCHost || isCommunicationGuestOnly)"
                           class="fas fa-info-circle automation-state__notification-mode--warning"
                           v-on:mouseenter="showAgentTooltip = true" v-on:mouseleave="showAgentTooltip = false"></i>
                        <tooltip v-bind:visible="showAgentTooltip" v-bind:position="'bottom'" v-bind:text="'Email will go to Agent and not Guest'"></tooltip>
                    </span>
                    <template v-if="!hideToggle">
                        <span class="automation-state__active">
                            <span><template v-if="!automation.active && (!isSendWhatsApp)">Off</template></span>
                            <i v-if="automation.active" v-on:click="confirmToggleAutomation()"  class="fas fa-toggle-on automation-state__active-toggle--on"></i>
                            <i v-if="!automation.active" v-on:click="confirmToggleAutomation()" class="fas fa-toggle-off automation-state__active-toggle--off"></i>
                            <span><template v-if="automation.active">On</template></span>
                        </span>
                    </template>
                    <template v-else>
                        <span> </span>
                    </template>
                    <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : updating, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>
                </div>

                <div v-if="automation.conditions.length > 0" class="automation-conditions">
                    <span class="automation-conditions__title"><i class="fas fa-filter"></i></span>
                    <div v-for="(condition, index) in automation.conditions" v-bind:key="index">
                        <span class="automation-conditions__condition">{{conditionTypeAsString(condition)}}</span>
                        <span class="automation-conditions__condition-operator" v-html="conditionOperatorAsIcon(condition)"></span>
                      <template v-if="isConditionValueSelectMultiple(condition.type, condition.operator)">
                        {{numberSelectedForCondition(condition.value)}} selected
                      </template>
                      <template v-else>
                        {{conditionValueAsString(condition)}}
                      </template>
                    </div>
                </div>

            </div>

        </div>

        <edit-event-automation v-bind:automation="automation" v-if="showEditDialog"/>

        <confirm-dialog v-bind:message="confirmDeleteMessage"
                        v-bind:callbackPrimaryName="'delete-automation'"
                        v-bind:callbackPrimaryReference="'' + _uid"
                        v-if="showConfirmDeleteDialog"/>

        <confirm-duplicate-automation-dialog v-bind:message="confirmDuplicateMessage"
                                             v-bind:callbackName="'duplicate-automation'"
                                             v-bind:callbackReference="'' + _uid"
                                             v-if="showConfirmDuplicateDialog"/>

        <confirm-toggle-automation-dialog v-bind:automation="automation"
                                          v-bind:callbackName="'toggle-automation'"
                                          v-bind:callbackReference="'' + _uid"
                                          v-if="showConfirmToggleDialog"/>
    </div>
</template>

<script>
    import EditEventAutomation from './EditEventAutomation.vue'
    import ConfirmToggleAutomationDialog from './ConfirmToggleAutomationDialog'
    import ConfirmDuplicateAutomationDialog from './ConfirmDuplicateAutomationDialog'

    import ConfirmDialog from '../ConfirmDialog.vue'
    import Tooltip from '../Tooltip'

    import {automationMixin} from "../../mixins/AutomationMixin"

    export default {
        name: "Automation.vue",
        components: { EditEventAutomation, ConfirmToggleAutomationDialog, ConfirmDuplicateAutomationDialog, ConfirmDialog, Tooltip },
        mixins: [ automationMixin ],
        props: {
            automation: Object,
            nextAutomation: Object,
            previousAutomation: Object,
            index: Number,
            beforeProcessEvent: Boolean,
            hideToggle: Boolean
        },
        data: function () {
            return {
            }
        },
        computed: {
        },
        methods: {
        },
        mounted() {
        },
        beforeDestroy () {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/pages/automations";
</style>

